<template>

    <Toast/>

    <MenuSiCompact/>

    <div class="px-6 surface-overlay relative">

        <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
            <li class="pr-3"><a @click="processHome" class="cursor-pointer"><i class="pi pi-home text-text-900"></i></a>
            </li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Analysis</a></li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">New Custom Filter</a></li>
        </ul>

        <div style="height: 8px;"></div>

        <div class="grid">
            <div class="col-12">
                <span>
                    Enter a name for your new custom filter.
                </span>
            </div>
        </div>


        <div v-show="activeTab === 31" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div style="height: 20px;"></div>

                    <div class="field">
                        <label for="name">Name</label>
                        <InputText id="name" v-model.trim="newCustomFilter.name" required="true"/>
                    </div>

                    <div class="field">
                        <label for="status">Use Top Ranked Criteria?</label>
                        <Dropdown v-model="newCustomFilter.type" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select an Option"/>
                    </div>

                    <Button label="Create" class="mr-2 mb-2" @click="createCustomFilter"></Button>

                </div>
            </div>
        </div>

    </div>


    <SiFooter/>

</template>

<script>
import {
    COLUMN_DEFINITIONS,
    STOCK_DATA_COLUMNS_EXTENDED,
    STOCK_DATA_COLUMNS_FULL,
    STOCK_DATA_COLUMNS_MINIMAL,
    STOCK_DATA_COLUMNS_BASIC_SEARCH,
    STOCK_CODES,
    STOCK_DATA_COLUMNS_COURSE
} from '@/config/stockdata';
import SiFooter from "@/components/heading/authentication/SiFooter.vue";
import MenuSiCompact from "@/components/simodule/MenuSiCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import {FilterMatchMode, FilterOperator} from "primevue/api";
import numeral from "numeral";
import ClientService from "@/service/ClientService";
import StockDataService from "@/service/StockDataService";
import moment from "moment";
import TaskService from "@/service/TaskService";
import StockService from "@/service/StockService";
import FilterService from "@/service/FilterService";
import FilterComponentService from "@/service/FilterComponentService";
import StockHistoryService from "@/service/StockHistoryService";
import SystemConfigService from "@/service/SystemConfigService";


export default {
    components: {
        MenuSiCompact,
        SiFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    created() {
        this.initFilters();
    },
    computed: {
        filteredColumns() {
            const filtered = this.columnConfig.filter(column => {
                const isTimePeriodMatch = !(
                    (column.field.includes('Year20Id') && this.selectedTimePeriod !== '20') ||
                    (column.field.includes('Year15Id') && this.selectedTimePeriod !== '15') ||
                    (column.field.includes('Year10Id') && this.selectedTimePeriod !== '10') ||
                    (column.field.includes('Year5Id') && this.selectedTimePeriod !== '5')
                );

                const isSelectedInMultiSelect = this.selectedColumns.includes(column.field);

                return isTimePeriodMatch && isSelectedInMultiSelect;
            });

            return filtered;
        },
        filteredColumnsForSearch() {
            const filtered = this.columnConfig.filter(column => {
                return this.selectedColumns.includes(column.field);
            });

            return filtered;
        }
    },
    // watch: {
    //     selectedColumns(newValue, oldValue) {
    //         console.warn("WATCHER: selectedColumns changed!");
    //         console.warn("  Old Value:", oldValue, " (Is Array:", Array.isArray(oldValue), ")");
    //         console.warn("  New Value:", newValue, " (Is Array:", Array.isArray(newValue), ")");
    //         if (!Array.isArray(newValue)) {
    //             console.error("CRITICAL: selectedColumns was set to a NON-ARRAY value!");
    //         }
    //     },
    // },
    async mounted() {
        console.log("[Overview][mounted] A.");

        this.loading = true;

        try {
            const [userData, userConfigData, systemConfigData] = await Promise.all([
                UserService.getUser(this.userStore.user.id),
                UserService.getUserConfig(this.userStore.user.id),
                SystemConfigService.getStatus()
            ]);

            this.profile = userData.data;
            this.userConfig = userConfigData.data;
            this.systemConfig = systemConfigData.data;
        } catch (e) {
            console.error("[Overview][mounted] Error fetching user data = ", e);

            this.userStore.clearUser();
            // this.$router.push("login");
            this.$router.replace('/siLogin');
            return;

        }

        console.log("[Overview][mounted] B.");

        console.log("[Overview][mounted] this.systemConfig = ", this.systemConfig);

        try {
            console.log("[Overview][mounted] 0.");

            await this.updateBasicOptions();

            console.log("[Overview][mounted] 1.");

            this.selectedTimePeriod = "20";
            this.selectedFormat = "Minimal";
            this.selectedCustomFilter = null;

            // console.log("[Overview][updateBasicOptions] Exchanges:", this.exchanges);
            // console.log("[Overview][updateBasicOptions] Countries:", this.countries);

            document.title = "Simply Investing"; // Update the browser tab title
            this.setFavicon("images/blocks/logos/favicon.simplyinvesting.96x96.png");

            if (this.exchanges.length > 0) {
                this.selectedExchange = this.exchanges[0].code;
            }

            if (this.countries.length > 0) {
                this.selectedCountry = this.countries[0].code;
            }

            console.log("[Overview][mounted] 2.");

            this.lastActiveTab = 1;
            this.activeFiltersForCounts = [];

            if (this.profile.rights === 'C') {
                this.selectedColumns = this.columnConfigCourse.map(column => column.field);

                this.activeFiltersForCounts.push(this.filterOptionDow30);
                this.activeFiltersForCounts.push(this.filterOptionTsx60);

                this.standardFilters.push(this.filterOptionDow30); // Use 'this.'
                this.standardFilters.push(this.filterOptionTsx60); // Use 'this.'

                this.selectedExchange = "NYSE";

            } else {
                this.selectedColumns = this.columnConfigMinimal.map(column => column.field);

                this.activeFiltersForCounts.push(...this.baseFilterOptions);
                this.activeFiltersForCounts.push(this.filterOptionDow30);
                this.activeFiltersForCounts.push(this.filterOptionTsx60);

                this.standardFilters.push(...this.baseFilterOptions); // Use 'this.'

                if (this.userConfig.enableSiUs === 'Y') {
                    this.standardFilters.push(this.filterOptionDow30); // Use 'this.'
                }
                if (this.userConfig.enableSiCa === 'Y') {
                    this.standardFilters.push(this.filterOptionTsx60); // Use 'this.'
                }

                this.selectedStandardFilter = "TR";

            }

            console.log("[Overview][mounted] 3.");

            await this.loadData();

            console.log("[Overview][mounted] 4.");
        } catch (e) {
            console.error("[Overview][mounted] Error fetching data = ", e);
            this.stockData = [];
            this.totalRecords = 0;

            if (e.response && e.response.status === 401) {
                console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                // this.$router.push('/siLogin'); // Redirect to the specified login route
                this.$router.replace('/siLogin');
            } else {
                // Handle other errors (e.g., network issues)
                this.userStore.clearUser();
                // this.$router.push('login'); // This is your existing fallback redirect
                this.$router.replace('/siLogin');
            }
            return;
        } finally {
            this.loading = false;
        }

        this.loading = false;
    },
    data() {

        return {
            debounceId: null,   // was _debounceId
            abortCtrl: null,    // was _abortCtrl
            requestSeq: 0,
            activeTab: 31,
            lastActiveTab: 1,
            totalRecords: 0,
            maxDividendYield: 0.0,
            loading: false,
            selectedFormat: "Minimal",
            selectedTimePeriod: "20",
            selectedCustomCriteria: "",
            confirmationResponse: 'N',
            searchCriteria: "",
            selectedStockDataTimePeriod: "20",
            selectedStockDataStockHistoryOption: "DPS",
            chartKey: 0,
            selectedExchange: null,
            selectedStandardFilter: null,
            selectedCountry: null,
            selectedCustomFilter: null,
            payments: null,
            columnsDefault: null,
            filters: null,
            columnConfig: STOCK_DATA_COLUMNS_FULL,
            columnConfigMinimal: STOCK_DATA_COLUMNS_MINIMAL,
            columnConfigExtended: STOCK_DATA_COLUMNS_EXTENDED,
            columnConfigBasicSearch: STOCK_DATA_COLUMNS_BASIC_SEARCH,
            columnConfigCourse: STOCK_DATA_COLUMNS_COURSE,
            columnDefinitions: COLUMN_DEFINITIONS,
            stockCodes: STOCK_CODES,
            profile: {},
            userConfig: {},
            systemConfig: {},
            supportData: {},
            newTask: {},
            client: {},
            newCustomFilter: {},
            customFilter: {},
            advancedSearchStockData: {},
            newCustomFilterComponent: {},
            customFilterComponent: {},
            filterCounts: {},
            specificStockData: {},
            lazyParams: {
                first: 0,
                rows: 100,
                sortField: null,
                sortOrder: null
            },
            countries: [],
            exchanges: [],
            standardFilters: [],
            customFiltersActive: [],
            customFilterComponents: [],
            customFilterStockDataList: [],
            stockData: [],
            sectorData: [],
            // industryData: [],
            industryData: [
                "Advertising Agencies",
                "Aerospace & Defense",
                "Agricultural - Commodities/Milling",
                "Agricultural - Machinery",
                "Agricultural Farm Products",
                "Agricultural Inputs",
                "Airlines, Airports & Air Services",
                "Aluminum",
                "Apparel - Footwear & Accessories",
                "Apparel - Manufacturers",
                "Apparel - Retail",
                "Asset Management",
                "Asset Management - Bonds",
                "Asset Management - Cryptocurrency",
                "Asset Management - Global",
                "Asset Management - Income",
                "Asset Management - Leveraged",
                "Auto - Dealerships",
                "Auto - Manufacturers",
                "Auto - Parts",
                "Auto - Recreational Vehicles",
                "Banks",
                "Banks - Diversified",
                "Banks - Regional",
                "Beverages - Alcoholic",
                "Beverages - Non-Alcoholic",
                "Beverages - Wineries & Distilleries",
                "Biotechnology",
                "Broadcasting",
                "Business Equipment & Supplies",
                "Chemicals",
                "Chemicals - Specialty",
                "Coal",
                "Communication Equipment",
                "Computer Hardware",
                "Conglomerates",
                "Construction",
                "Construction Materials",
                "Consulting Services",
                "Consumer Electronics",
                "Copper",
                "Department Stores",
                "Discount Stores",
                "Diversified Utilities",
                "Drug Manufacturers - General",
                "Drug Manufacturers - Specialty & Generic",
                "Education & Training Services",
                "Electrical Equipment & Parts",
                "Electronic Gaming & Multimedia",
                "Engineering & Construction",
                "Entertainment",
                "Environmental Services",
                "Financial - Capital Markets",
                "Financial - Conglomerates",
                "Financial - Credit Services",
                "Financial - Data & Stock Exchanges",
                "Financial - Diversified",
                "Financial - Mortgages",
                "Food Confectioners",
                "Food Distribution",
                "Furnishings, Fixtures & Appliances",
                "Gambling, Resorts & Casinos",
                "General Transportation",
                "General Utilities",
                "Gold",
                "Grocery Stores",
                "Hardware, Equipment & Parts",
                "Home Improvement",
                "Household & Personal Products",
                "Independent Power Producers",
                "Industrial - Capital Goods",
                "Industrial - Distribution",
                "Industrial - Infrastructure Operations",
                "Industrial - Machinery",
                "Industrial - Pollution & Treatment Controls",
                "Industrial - Specialties",
                "Industrial Materials",
                "Information Technology Services",
                "Insurance - Brokers",
                "Insurance - Diversified",
                "Insurance - Life",
                "Insurance - Property & Casualty",
                "Insurance - Reinsurance",
                "Insurance - Specialty",
                "Integrated Freight & Logistics",
                "Internet Content & Information",
                "Investment - Banking & Investment Services",
                "Leisure",
                "Luxury Goods",
                "Manufacturing - Metal Fabrication",
                "Manufacturing - Miscellaneous",
                "Manufacturing - Textiles",
                "Manufacturing - Tools & Accessories",
                "Marine Shipping",
                "Media & Entertainment",
                "Medical - Care Facilities",
                "Medical - Devices",
                "Medical - Diagnostics & Research",
                "Medical - Distribution",
                "Medical - Equipment & Services",
                "Medical - Healthcare Information Services",
                "Medical - Healthcare Plans",
                "Medical - Instruments & Supplies",
                "Medical - Pharmaceuticals",
                "Medical - Specialties",
                "Oil & Gas Drilling",
                "Oil & Gas Energy",
                "Oil & Gas Equipment & Services",
                "Oil & Gas Exploration & Production",
                "Oil & Gas Integrated",
                "Oil & Gas Midstream",
                "Oil & Gas Refining & Marketing",
                "Other Precious Metals",
                "Packaging & Containers",
                "Packaged Foods",
                "Paper, Lumber & Forest Products",
                "Personal Products & Services",
                "Publishing",
                "Railroads",
                "Real Estate - Development",
                "Real Estate - Diversified",
                "Real Estate - General",
                "Real Estate - Services",
                "REIT - Diversified",
                "REIT - Healthcare Facilities",
                "REIT - Hotel & Motel",
                "REIT - Industrial",
                "REIT - Mortgage",
                "REIT - Office",
                "REIT - Residential",
                "REIT - Retail",
                "REIT - Specialty",
                "Regulated Electric",
                "Regulated Gas",
                "Regulated Water",
                "Rental & Leasing Services",
                "Renewable Utilities",
                "Restaurants",
                "Residential Construction",
                "Security & Protection Services",
                "Semiconductors",
                "Shell Companies",
                "Silver",
                "Solar",
                "Software - Application",
                "Software - Infrastructure",
                "Software - Services",
                "Specialty Business Services",
                "Specialty Retail",
                "Staffing & Employment Services",
                "Steel",
                "Telecommunications Services",
                "Technology Distributors",
                "Tobacco",
                "Travel Lodging",
                "Travel Services",
                "Trucking",
                "Uranium",
                "Waste Management"
            ],
            selectedColumns: STOCK_DATA_COLUMNS_MINIMAL.map(column => column.field), // <-- FIX THIS LINE
            filteredCodes:
                [],
            searchStockData:
                [],
            advancedSearchStockDataList:
                [],
            industryDropdownData:
                [],
            stockHistory:
                [],
            specificStockDataArray:
                [],
            lineData:
                [],
            lineOptions:
                [],
            activeFiltersForCounts:
                [],
            baseCountryOptions:
                [
                    {name: 'USA', code: 'US'},
                    {name: 'Canada', code: 'CA'},
                    {name: 'UK', code: 'UK'},
                    {name: 'South Africa', code: 'ZA'},
                ],
            baseExchangeOptions:
                [
                    {name: 'NYSE', code: 'NYSE'},
                    {name: 'NASDAQ', code: 'NASDAQ'},
                    {name: 'TSX', code: 'TO'},
                    {name: 'LSE', code: 'LSE'},
                    {name: 'JSE', code: 'JSE'},
                ],
            baseFilterOptions:
                [
                    {name: 'Top Ranked', code: 'TR'},
                    {name: 'Runners-Up', code: 'RU'},
                    {name: 'Dividend Stocks Under-valued', code: 'DSU'},
                    {name: 'Dividend Stocks Over-valued', code: 'DSO'},
                    {name: 'Dividend Stocks Deep-valued', code: 'DSD'},
                    {name: 'Non Dividend Stocks Under-valued', code: 'NDSU'},
                    {name: 'Non Dividend Stocks Over-valued', code: 'NDSO'},
                    {name: 'Non Dividend Stocks Deep-valued', code: 'NDSD'},
                ],
            filterOptionDow30:
                {
                    name: 'DOW 30', code:
                        'DOW30'
                }
            ,
            filterOptionTsx60: {
                name: 'TSX 60', code:
                    'TSX60'
            }
            ,
            customFilters: [],
            timePeriods:
                [
                    {name: '20 Year', code: '20'},
                    {name: '15 Year', code: '15'},
                    {name: '10 Year', code: '10'},
                    {name: '5 Year', code: '5'}
                ],
            timePeriodsGraph:
                [
                    {name: '20 Year', code: '20'},
                    {name: '15 Year', code: '15'},
                    {name: '10 Year', code: '10'},
                    {name: '5 Year', code: '5'},
                    {name: 'Maximum', code: 'Maximum'},
                ],
            formats:
                [
                    {name: 'Minimal View', code: 'Minimal'},
                    {name: 'Extended View', code: 'Extended'}
                ],
            stockHistoryOptions:
                [
                    {name: 'Dividends Per Share', code: 'DPS'},
                    {name: 'Low Price', code: 'LSP'},
                    {name: 'High Price', code: 'HSP'},
                    {name: 'Average Price', code: 'ASP'},
                    {name: 'EPS', code: 'EPS'}
                ],
            supportTypes:
                [
                    {name: 'Technical Issue', code: 'Technical Issue'},
                    {name: 'Billing & Payments', code: 'Billing & Payments'},
                    {name: 'Account Management', code: 'Account Management'},
                    {name: 'Feature Request', code: 'Feature Request'},
                    {name: 'How-To / Usage Questions', code: 'How-To / Usage Questions'},
                    {name: 'Performance Issues', code: 'Performance Issues'},
                    {name: 'Other', code: 'Other'}
                ],
            siCriteriaOptions:
                [
                    {name: '1 out of 10', code: 1},
                    {name: '2 out of 10', code: 2},
                    {name: '3 out of 10', code: 3},
                    {name: '4 out of 10', code: 4},
                    {name: '5 out of 10', code: 5},
                    {name: '6 out of 10', code: 6},
                    {name: '7 out of 10', code: 7},
                    {name: '8 out of 10', code: 8},
                    {name: '9 out of 10', code: 9},
                    {name: '10 out of 10', code: 10}
                ],
            confirmationTypes:
                [
                    {name: 'Yes', code: 'Y'},
                    {name: 'No', code: 'N'}
                ],
            statusTypes:
                [
                    {name: 'Active', code: 'A'},
                    {name: 'Inactive', code: 'I'}
                ],
            operators:
                [
                    {name: 'Equal', code: 'E'},
                    {name: 'Not Equal', code: 'N'},
                    {name: 'Greater Than', code: 'G'},
                    {name: 'Less Than', code: 'L'},
                    {name: 'Greater Than and Equal', code: 'H'},
                    {name: 'Less Than and Equal', code: 'M'},
                    {name: 'None Needed', code: '0'}
                ],
            underOrOverValuedOptions:
                [
                    {name: 'Undervalued', code: 'U'},
                    {name: 'Overvalued', code: 'O'}
                ],
            consecutiveDividendIncreasesOptions:
                [
                    {name: '10 to 14 Years (Achievers)', code: -1},
                    {name: '15 to 24 Years (Contenders)', code: -2},
                    {name: '25 to 49 Years (Aristocrats/Champions)', code: -3},
                    {name: '50 Years or more (Kings)', code: -4},
                    {name: 'Enter your own value', code: -5},
                ],

        }
    },
    methods: {
        setFavicon(url) {
            // Check if a <link rel="icon"> tag already exists
            let faviconLink = document.querySelector("link[rel='icon']");

            if (!faviconLink) {
                // Create a new <link> element if one doesn't exist
                faviconLink = document.createElement("link");
                faviconLink.rel = "icon";
                document.head.appendChild(faviconLink);
            }

            // Update the favicon URL
            faviconLink.href = url;
        },
        closeAllMenus() {
            document.body.click(); // triggers hideOnOutsideClick

            document.querySelectorAll('.p-component-overlay, .p-menu-overlay, .p-overlay, .p-tieredmenu-overlay')
                .forEach(el => el.remove());
        },
        safeNavigate(target) {
            this.closeAllMenus();
            setTimeout(() => {
                this.$router.push(target);
            }, 0);
        },
        processHome() {
            console.log("[MenuConfiguration][processHome] Beginning.");
            this.closeAllMenus();
            this.safeNavigate('/siHome');
        },
        onComplete(event) {
            console.log('[Overview][onComplete] event = ', event);

            const q = (event?.query || '').trim();

            if (q.length < 2) {
                this.filteredCodes = [];
                this.cancelPending();
                return;
            }

            // Debounce 300 ms
            clearTimeout(this.debounceId);
            this.debounceId = setTimeout(() => this.doSearch(q), 300);
        },
        cancelPending() {
            if (this.abortCtrl) {
                this.abortCtrl.abort();
                this.abortCtrl = null;
            }
        },

        doSearch(query) {
            console.log('[Overview][doSearch] query = ', query);
            console.log('[Overview][doSearch] this.selectedCountry = ', this.selectedCountry);

            // cancel any in-flight request
            this.cancelPending();

            // new controller for this request
            this.abortCtrl = new AbortController();

            // bump sequence to ignore stale responses
            const seq = ++this.requestSeq;

            StockService.searchStocksForCountryByName(
                this.selectedCountry,
                query.toLowerCase(),
                {signal: this.abortCtrl.signal} // axios supports AbortController
            )
                .then((res) => {
                    if (seq !== this.requestSeq) return; // ignore stale

                    const list = res.data || [];
                    this.filteredCodes = list.map((stock) => ({
                        label: `${stock.name} (${stock.code})`,
                        value: stock.code,
                    }));
                })
                .catch((e) => {
                    // ignore aborts
                    if (e.name === 'CanceledError' || e.code === 'ERR_CANCELED') return;

                    console.log('[Overview][searchCodes] Error = ', e);
                    if (e.response && e.response.status === 401) {
                        this.$router.replace('/siLogin');
                    } else {
                        this.userStore.clearUser();
                        this.$router.replace('/siLogin');
                    }
                })
                .finally(() => {
                    this.abortCtrl = null;
                });
        },
        async updateBasicOptions() {
            this.exchanges = [];
            if (this.profile.rights === 'C') {
                this.exchanges.push(this.baseExchangeOptions.find(opt => opt.code === 'NYSE'));
                this.exchanges.push(this.baseExchangeOptions.find(opt => opt.code === 'NASDAQ'));
                this.exchanges.push(this.baseExchangeOptions.find(opt => opt.code === 'TO'));
            } else {
                if (this.userConfig.enableSiUs === 'Y') {
                    this.exchanges.push(this.baseExchangeOptions.find(opt => opt.code === 'NYSE'));
                    this.exchanges.push(this.baseExchangeOptions.find(opt => opt.code === 'NASDAQ'));
                }
                if (this.userConfig.enableSiCa === 'Y') {
                    this.exchanges.push(this.baseExchangeOptions.find(opt => opt.code === 'TO'));
                }
                if (this.userConfig.enableSiUk === 'Y') {
                    this.exchanges.push(this.baseExchangeOptions.find(opt => opt.code === 'LSE'));
                }
                if (this.userConfig.enableSiZa === 'Y') {
                    this.exchanges.push(this.baseExchangeOptions.find(opt => opt.code === 'JSE'));
                }
            }
            this.exchanges = this.exchanges.filter(Boolean); // Filter out any undefineds


            // Populate Countries based on user rights
            this.countries = [];
            if (this.profile.rights === 'C') {
                this.countries.push(this.baseCountryOptions.find(opt => opt.code === 'US'));
                this.countries.push(this.baseCountryOptions.find(opt => opt.code === 'CA'));
            } else {
                if (this.userConfig.enableSiUs === 'Y') {
                    this.countries.push(this.baseCountryOptions.find(opt => opt.code === 'US'));
                }
                if (this.userConfig.enableSiCa === 'Y') {
                    this.countries.push(this.baseCountryOptions.find(opt => opt.code === 'CA'));
                }
                if (this.userConfig.enableSiUk === 'Y') {
                    this.countries.push(this.baseCountryOptions.find(opt => opt.code === 'UK'));
                }
                if (this.userConfig.enableSiZa === 'Y') {
                    this.countries.push(this.baseCountryOptions.find(opt => opt.code === 'ZA'));
                }
            }
            this.countries = this.countries.filter(Boolean);
        },
        async updateStandardFiltersWithCounts() {

            let activeFilters = [];

            if (this.profile.rights === 'C') {
                activeFilters.push(this.filterOptionDow30); // Use 'this.'
                activeFilters.push(this.filterOptionTsx60); // Use 'this.'
            } else {
                activeFilters.push(...this.baseFilterOptions); // Use 'this.'

                if (this.userConfig.enableSiUs === 'Y') {
                    activeFilters.push(this.filterOptionDow30); // Use 'this.'
                }
                if (this.userConfig.enableSiCa === 'Y') {
                    activeFilters.push(this.filterOptionTsx60); // Use 'this.'
                }
            }

            console.log("[Overview][updateStandardFiltersWithCounts] this.filterCounts = ", this.filterCounts);
            console.log("[Overview][updateStandardFiltersWithCounts] activeFilters = ", activeFilters);

            activeFilters.forEach(filter => {
                if (filter.code !== undefined && this.filterCounts[filter.code] !== undefined) {
                    filter.count = this.filterCounts[filter.code];
                } else {
                    console.warn(`Count not found or filter code missing for filter:`, filter);
                    filter.count = 0; // Or set to a default value like 0
                }
            });

            console.log("[Overview][updateStandardFiltersWithCounts] activeFilters = ", activeFilters);

            const counts = this.filterCounts;
            this.standardFilters = activeFilters.map(filter => {
                const count = counts[filter.code] !== undefined ? counts[filter.code] : 0;
                return {
                    ...filter,
                    name: `${filter.name} (${count})`
                };
            });
        },
        async loadData() {
            this.loading = true;
            try {
                console.log("[Overview][loadData] Before calling getStockDataCountsByFilter");

                // const filtersToCount = this.activeFiltersForCounts.map(f => f.code);

                const [clientData, customFilterInfo,
                    customFilterActiveInfo, dividendTrapInfo, countInfo] = await Promise.all([
                    ClientService.getClientForUser(this.userStore.user.id),
                    FilterService.getUserFilters(this.userStore.user.id),
                    FilterService.getUserActiveFilters(this.userStore.user.id),
                    StockDataService.findDividendTrapForExchange(this.selectedExchange, 'S'),
                    StockDataService.getStockDataCountsByFilterNew(this.selectedExchange, 'S',
                        "",
                        this.selectedTimePeriod)
                ]);

                console.log("[Overview][loadData] After calling getStockDataCountsByFilter. countInfo = ", countInfo);

                console.log("[Overview][loadData] Before calling getAllStockDataForExchangeLazyLoading");

                const {data, totalRecords} =
                    await StockDataService.getAllStockDataForExchangeLazyLoading(
                        this.selectedExchange, 'S',
                        this.lazyParams,
                        this.filters['global']?.value || '',
                        this.selectedStandardFilter,
                        this.selectedTimePeriod,
                        this.lazyParams.customFilterId);

                console.log("[Overview][loadData] After calling getAllStockDataForExchangeLazyLoading");

                this.stockData = data;
                this.totalRecords = totalRecords;

                this.client = clientData.data;

                this.customFilters = customFilterInfo.data;
                this.customFiltersActive = customFilterActiveInfo.data;

                this.maxDividendYield = dividendTrapInfo.data;

                this.filterCounts = countInfo;

                await this.updateStandardFiltersWithCounts();

            } catch (e) {
                console.error("[Payments][loadData] Error loading payments:", e);
                this.payments = [];
                this.totalRecords = 0;

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            }
            this.loading = false;
        },
        onPage(event) {
            this.lazyParams.first = event.first;
            this.lazyParams.rows = event.rows;
            this.loadData();
        },
        onSort(event) {
            console.log("[Overview][onSort] this.activeTab = ", this.activeTab);
            console.log("[Overview][onSort] this.lastActiveTab = ", this.lastActiveTab);

            const isSearchTab = this.activeTab === 23;

            console.log("[Overview][onSort] isSearchTab = ", isSearchTab);

            if (isSearchTab) {
                if (!event.sortField) {
                    return;
                }

                const field = event.sortField;
                const dir = event.sortOrder; // 1 = asc, -1 = desc

                this.stockData.sort((a, b) => {
                    const va = a[field], vb = b[field];
                    if (va == null && vb == null) return 0;
                    if (va == null) return 1 * dir;
                    if (vb == null) return -1 * dir;
                    if (va < vb) return -1 * dir;
                    if (va > vb) return 1 * dir;
                    return 0;
                });

                return;
            }

            if (event.sortField) {
                this.lazyParams.sortField = event.sortField;
                this.lazyParams.sortOrder = event.sortOrder;
            } else {
                this.lazyParams.sortField = null;
                this.lazyParams.sortOrder = null;
            }
            this.loadData();
        },
        onFilter(event) {
            this.lazyParams.filters = event.filters;
            this.loadData();
        },
        onSearch() {
            this.lazyParams.first = 0;
            this.loadData();
        },
        onToggleStandardFilters() {
            this.lazyParams.first = 0;
            this.loadData();
        },
        clearFilter() {
            this.initFilters();
            this.selectedStandardFilter = null;
            this.lazyParams.filters = {};
            this.lazyParams.first = 0;
            this.loadData();
        },
        async restoreToOriginal() {
            this.$router.go(0);
        },
        initFilters() {
            this.filters = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'id': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'uniqueId': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'clientName': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'paid': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'description': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'amount': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                }
            }
        },
        callResetHome() {
            this.lastActiveTab = 1;
            this.selectedCustomFilter = null;
            this.activeTab = 1;
        },
        callReset() {
            console.log("[Overview][callReset] this.lastActiveTab = ", this.lastActiveTab);

            if (this.lastActiveTab === 1) {
                // this.lastActiveTab = 1;
                this.selectedCustomFilter = null;
                this.activeTab = 1;
            } else {
                this.selectedCustomFilter = null;
                this.activeTab = 23;
            }
        },
        async callResetAdvancedSearch() {
            this.activeTab = 21;
            this.advancedSearchStockData.siCriteriaYear5Id125 = null;
            this.advancedSearchStockData.undervaluedVsOvervaluedStatusYear5Id132 = null;
            this.advancedSearchStockData.siCriteriaYear10Id126 = null;
            this.advancedSearchStockData.undervaluedVsOvervaluedStatusYear10Id133 = null;
            this.advancedSearchStockData.siCriteriaYear15Id127 = null;
            this.advancedSearchStockData.undervaluedVsOvervaluedStatusYear15Id134 = null;
            this.advancedSearchStockData.siCriteriaYear20Id128 = null;
            this.advancedSearchStockData.undervaluedVsOvervaluedStatusYear20Id135 = null;
            this.advancedSearchStockData.exchangeId073 = null;
            this.advancedSearchStockData.sectorId121 = null;
            this.advancedSearchStockData.industryId081 = null;
            this.advancedSearchStockData.yearsDividendIncreasesId047 = null;
            this.advancedSearchStockData.consecutiveDividendIncreasesInput = null;
            this.advancedSearchStockData.consecutiveDividendIncreasesOption = null;
        },
        onToggleColumns(event) {
            this.selectedColumns = event.value;
        },
        handleDividendTrapInfo() {
            this.activeTab = 3;
        },
        formatAmount(value) {
            if (value) {
                return numeral(String(value)).format('0,0.00');
            } else {
                return 0;
            }
        },
        formatNumeric(value) {
            if (value) {
                return numeral(value).format('0,0');
            } else {
                return '0';
            }
        },
        formatString(value) {
            if (value) {
                return String(value).substring(0, 50);
            } else {
                return '';
            }
        },
        async onFilterChange() {
            this.selectedCustomFilter = null;
            await this.loadData();
        },
        async onExchangeChange() {
            this.selectedCustomFilter = null;

            await this.loadData();
        },
        async onTimePeriodChange() {
            this.selectedCustomFilter = null;

            await this.loadData();
        },
        onFormatChange() {
            this.selectedCustomFilter = null;

            if (this.selectedFormat === "Minimal") {
                this.selectedColumns = this.columnConfigMinimal.map(column => column.field);
            } else {
                this.selectedColumns = this.columnConfigExtended.map(column => column.field);
            }
        },
        onFormatChangeForSearch() {
            this.selectedCustomFilter = null;

            if (this.selectedFormat === "Minimal") {
                this.selectedColumns = this.columnConfigBasicSearch.map(column => column.field);
            } else {
                this.selectedColumns = this.columnConfigExtended.map(column => column.field);
            }
        },
        callBasicSearch() {
            if (this.countries.length > 0) {
                this.selectedCountry = this.countries[0].code;
            }

            this.searchCriteria = "";
            this.activeTab = 20;
        },
        async callAdvancedSearch() {
            this.activeTab = 21;

            const [sectorDataInfo] = await Promise.all([
                StockDataService.findSectorForExchange(this.selectedExchange, 'S'),
            ]);

            this.sectorData = sectorDataInfo.data;
        },
        callCompareStocks() {
            this.selectedCountry = "US";
            this.searchCriteria = "";
            this.activeTab = 22;
        },
        callColumnDefinitions() {
            this.activeTab = 10;
        },
        callSupport() {
            this.supportData = {};
            this.supportData.type = "Feature Request";

            this.newTask = {
                type: 'S',
                severity: 'N',
                category: 'F',
                priority: 1,
                max: 259200,
                clientVisible: 'N',
                due: moment().add(5, 'days').startOf('hour').toDate()
            };

            this.activeTab = 11;
        },
        async processSupport() {
            this.loading = true;

            if (this.supportData.description) {

                try {
                    this.newTask = {
                        type: 'S',
                        severity: 'N',
                        category: 'F',
                        priority: 1,
                        max: 259200,
                        clientVisible: 'N',
                        due: moment().add(5, 'days').startOf('hour').toDate()
                    };

                    var newTaskDto = {
                        companyId: this.profile.companyId,
                        requesterId: this.userStore.user.id,
                        clientId: this.client.id,
                        description: 'Overview Page :: ' + this.supportData.type + ' :: ' + this.supportData.description,
                        max: this.newTask.max,
                        type: this.newTask.type,
                        severity: this.newTask.severity,
                        category: this.newTask.category,
                        priority: this.newTask.priority,
                        note: this.supportData.note,
                        clientVisible: this.newTask.clientVisible,
                        due: moment(this.newTask.due).format('YYYY-MM-DD HH:mm'),
                    };

                    await TaskService.createTask(this.profile.companyId, newTaskDto);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Created support request',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Overview][processSupport] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create support request. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 12;
            this.loading = false;
        },
        searchCodes(event) {
            StockService.searchStocksForCountryByName(this.selectedCountry, event.query.toLowerCase())
                .then(data => {
                    this.filteredCodes = data.data.map(stock => ({
                        label: `${stock.name} (${stock.code})`,
                        value: stock.code // or the entire stock object, depending on your needs
                    }));
                })
                .catch(e => {
                    console.log("[Overview][searchCodes] Error = ", e);

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                });

        },
        async processBasicSearch() {
            this.loading = true;

            if (this.searchCriteria.value === '') {
                this.activeTab = 20;
            } else {
                // const [stockDataInfo] = await Promise.all([
                //     StockDataService.searchStockDataForCountryAndSpecificCode(
                //         this.selectedCountry, 'S', this.searchCriteria.value, this.lazyParams)
                // ]);
                //
                // this.stockData = Array.isArray(stockDataInfo.data.content) ? stockDataInfo.data.content : [];
                // this.totalRecords = stockDataInfo.data?.totalElements || 0;

                const [stockDataInfo] = await Promise.all([
                    StockDataService.searchStockDataForCountryAndTypeAndAnyCodeExtended(
                        this.selectedCountry, 'S', this.searchCriteria.value)
                ]);

                this.stockData = Array.isArray(stockDataInfo) ? stockDataInfo : [];

                console.log("[Overview][processBasicSearch] this.stockData = ", this.stockData);

                if (this.profile.rights === 'C') {
                    this.activeTab = 23;
                    this.lastActiveTab = 29;
                    this.selectedColumns = this.columnConfigCourse.map(column => column.field);

                } else {
                    this.activeTab = 23;
                    this.lastActiveTab = 20;
                    this.selectedColumns = this.columnConfigBasicSearch.map(column => column.field);
                }

                this.selectedTimePeriod = "20";
                this.selectedFormat = "Minimal";
            }

            this.loading = false;
        },
        async processCompareStock() {
            this.loading = true;
            this.lastActiveTab = 22;

            if (this.searchCriteria.trim() === '') {
                this.activeTab = 22;
            } else {
                // const [stockDataInfo] = await Promise.all([
                //     StockDataService.searchStockDataForCountryAndSpecificCode(
                //         this.selectedCountry, 'S', this.searchCriteria.trim(), this.lazyParams)
                // ]);
                //
                // this.stockData = Array.isArray(stockDataInfo.data.content) ? stockDataInfo.data.content : [];
                // this.totalRecords = stockDataInfo.data?.totalElements || 0;

                const [stockDataInfo] = await Promise.all([
                    StockDataService.searchStockDataForCountryAndTypeAndAnyCodeExtended(
                        this.selectedCountry, 'S', this.searchCriteria.trim())
                ]);

                this.stockData = Array.isArray(stockDataInfo) ? stockDataInfo : [];

                console.log("[Overview][processCompareStock] this.stockData = ", this.stockData);

                this.selectedColumns = this.columnConfigBasicSearch.map(column => column.field);
                this.selectedFormat = "Minimal";
                this.selectedTimePeriod = "20";

                this.activeTab = 23;
            }

            this.loading = false;
        },
        async processAdvancedSearch() {

            this.loading = true;
            this.lastActiveTab = 21;

            if (this.advancedSearchStockData.consecutiveDividendIncreasesOption === -1) {
                this.advancedSearchStockData.yearsDividendIncreasesId047Start = 10;
                this.advancedSearchStockData.yearsDividendIncreasesId047End = 14;
            } else if (this.advancedSearchStockData.consecutiveDividendIncreasesOption === -2) {
                this.advancedSearchStockData.yearsDividendIncreasesId047Start = 15;
                this.advancedSearchStockData.yearsDividendIncreasesId047End = 24;
            } else if (this.advancedSearchStockData.consecutiveDividendIncreasesOption === -3) {
                this.advancedSearchStockData.yearsDividendIncreasesId047Start = 25;
                this.advancedSearchStockData.yearsDividendIncreasesId047End = 49;
            } else if (this.advancedSearchStockData.consecutiveDividendIncreasesOption === -4) {
                this.advancedSearchStockData.yearsDividendIncreasesId047Start = 50;
                this.advancedSearchStockData.yearsDividendIncreasesId047End = 200;
            } else {
                this.advancedSearchStockData.yearsDividendIncreasesId047Start = parseInt(this.advancedSearchStockData.consecutiveDividendIncreasesInput, 10);
                this.advancedSearchStockData.yearsDividendIncreasesId047End = parseInt(this.advancedSearchStockData.consecutiveDividendIncreasesInput, 10);
            }

            try {
                console.log("[Overview][processAdvancedSearch] this.advancedSearchStockData = ", this.advancedSearchStockData);

                const [stockDataInfo] = await Promise.all([
                    StockDataService.processAdvancedSearchForStockDataExtended(this.advancedSearchStockData)
                ]);

                this.stockData = stockDataInfo;

                console.log("[Overview][processAdvancedSearch] this.stockData = ", this.stockData);

                this.loading = false;

            } catch (e) {
                console.log("[Overview][processAdvancedSearch] error = ", e);
                this.stockData = {};

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            } finally {
                this.loading = false;
            }

            this.selectedColumns = this.columnConfigBasicSearch.map(column => column.field);
            this.selectedFormat = "Minimal";
            this.selectedTimePeriod = "20";

            this.activeTab = 23;

        },
        async callManageFilters() {
            this.activeTab = 30;
            this.customFilter = {};

            try {
                const [customFilterInfo, customFilterActiveInfo] = await Promise.all([
                    FilterService.getUserFilters(this.userStore.user.id),
                    FilterService.getUserActiveFilters(this.userStore.user.id)
                ]);

                this.customFilters = customFilterInfo.data;
                this.customFiltersActive = customFilterActiveInfo.data;

            } catch (e) {
                console.error("[Overview][callManageFilters] Error fetching filter data = ", e);

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            }
        },
        callNewCustomFilter() {
            this.newCustomFilter = {};
            this.newCustomFilter.type = 'N';
            this.activeTab = 31;
        },
        callUpdateCustomFilter(data) {
            this.customFilter = data;
            this.activeTab = 32;
        },
        callDeleteCustomFilter(data) {
            this.customFilter = data;
            this.confirmationResponse = 'N';
            this.activeTab = 33;
        },
        async callConfigureCustomFilter(data) {
            this.customFilter = data;
            this.activeTab = 34;

            try {
                const [customFilterComponentsInfo] = await Promise.all([
                    FilterComponentService.getFilterComponentsForFilter(this.customFilter.id)
                ]);

                this.customFilterComponents = customFilterComponentsInfo.data;

                console.log("[Overview][callConfigureCustomFilter] this.customFilterComponents = ", this.customFilterComponents);

            } catch (e) {
                console.error("[Overview][callConfigureCustomFilter] Error fetching filter data = ", e);

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            }

        },
        callNewCustomFilterComponent() {
            this.newCustomFilterComponent = {};
            this.newCustomFilterComponent.visible = 'Y';
            this.newCustomFilterComponent.status = 'A';
            this.newCustomFilterComponent.operator = 'E';
            this.activeTab = 35;
        },
        callUpdateCustomFilterComponent(data) {
            this.customFilterComponent = data;
            this.activeTab = 36;
        },
        callDeleteCustomFilterComponent(data) {
            this.customFilterComponent = data;
            this.confirmationResponse = 'N';
            this.activeTab = 37;
        },
        async createCustomFilter() {
            this.loading = true;

            if (this.newCustomFilter.name) {

                try {
                    var customFilterDto = {
                        name: this.newCustomFilter.name,
                        status: 'A'
                    };

                    if (this.newCustomFilter.type === 'Y') {
                        await FilterService.createFilterWithType(this.userStore.user.id, "T", customFilterDto);
                    } else {
                        await FilterService.createFilter(this.userStore.user.id, customFilterDto);
                    }

                    try {
                        const [customFilterInfo, customFilterActiveInfo] = await Promise.all([
                            FilterService.getUserFilters(this.userStore.user.id),
                            FilterService.getUserActiveFilters(this.userStore.user.id)
                        ]);

                        this.customFilters = customFilterInfo.data;
                        this.customFiltersActive = customFilterActiveInfo.data;

                    } catch (e) {
                        console.error("[Overview][callManageFilters] Error fetching filter data = ", e);

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;
                    }

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Created custom filter',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Overview][createCustomFilter] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create custom filter. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 31;
            this.loading = false;
        },
        async updateCustomFilter() {
            this.loading = true;

            if (this.customFilter.id) {

                try {
                    var customFilterDto = {
                        name: this.customFilter.name,
                        status: this.customFilter.status
                    };

                    await FilterService.updateFilter(this.customFilter.id, customFilterDto);

                    const [customFilterInfo, customFilterActiveInfo] = await Promise.all([
                        FilterService.getUserFilters(this.userStore.user.id),
                        FilterService.getUserActiveFilters(this.userStore.user.id)
                    ]);

                    this.customFilters = customFilterInfo.data;
                    this.customFiltersActive = customFilterActiveInfo.data;

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Updated custom filter',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Overview][updateCustomFilter] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to update custom filter. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 30;
            this.loading = false;
        },
        async deleteCustomFilter() {
            this.loading = true;

            if (this.customFilter.id) {

                try {
                    await FilterService.deleteFilter(this.customFilter.id);

                    const [customFilterInfo, customFilterActiveInfo] = await Promise.all([
                        FilterService.getUserFilters(this.userStore.user.id),
                        FilterService.getUserActiveFilters(this.userStore.user.id)
                    ]);

                    this.customFilters = customFilterInfo.data;
                    this.customFiltersActive = customFilterActiveInfo.data;

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Deleted custom filter',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Overview][deleteCustomFilter] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to delete custom filter. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 30;
            this.loading = false;
        },
        async createCustomFilterComponent() {
            this.loading = true;

            if (this.newCustomFilterComponent.code) {

                try {

                    if (this.newCustomFilterComponent.operator === '0') {
                        this.newCustomFilterComponent.value = null;
                    }

                    var customFilterComponentDto = {
                        code: this.newCustomFilterComponent.code,
                        operator: this.newCustomFilterComponent.operator,
                        value: this.newCustomFilterComponent.value,
                        visible: this.newCustomFilterComponent.visible,
                        status: this.newCustomFilterComponent.status
                    };

                    await FilterComponentService.createFilterComponent(this.customFilter.id, customFilterComponentDto);

                    try {
                        const [customFilterComponentsInfo] = await Promise.all([
                            FilterComponentService.getFilterComponentsForFilter(this.customFilter.id)
                        ]);

                        this.customFilterComponents = customFilterComponentsInfo.data;

                    } catch (e) {
                        console.error("[Overview][callConfigureCustomFilter] Error fetching filter data = ", e);

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;
                    }

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Created custom filter component',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Overview][createCustomFilter] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create custom filter component. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 34;
            this.loading = false;
        },
        async updateCustomFilterComponent() {
            this.loading = true;

            if (this.customFilterComponent.code) {

                try {
                    if (this.customFilterComponent.operator === '0') {
                        this.customFilterComponent.value = null;
                    }

                    var customFilterComponentDto = {
                        code: this.customFilterComponent.code,
                        operator: this.customFilterComponent.operator,
                        value: this.customFilterComponent.value,
                        visible: this.customFilterComponent.visible,
                        status: this.customFilterComponent.status
                    };

                    await FilterComponentService.updateFilterComponent(this.customFilterComponent.id, customFilterComponentDto);

                    try {
                        const [customFilterComponentsInfo] = await Promise.all([
                            FilterComponentService.getFilterComponentsForFilter(this.customFilter.id)
                        ]);

                        this.customFilterComponents = customFilterComponentsInfo.data;
                        // console.log("[Overview][callConfigureCustomFilter] this.customFilterComponents = ", this.customFilterComponents);

                    } catch (e) {
                        console.error("[Overview][callConfigureCustomFilter] Error fetching filter data = ", e);

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;
                    }

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Created custom filter component',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Overview][createCustomFilter] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create custom filter component. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 34;
            this.loading = false;
        },
        async deleteCustomFilterComponent() {
            this.loading = true;

            if (this.customFilterComponent.id) {

                try {
                    await FilterComponentService.deleteFilterComponent(this.customFilterComponent.id);

                    try {
                        const [customFilterComponentsInfo] = await Promise.all([
                            FilterComponentService.getFilterComponentsForFilter(this.customFilter.id)
                        ]);

                        this.customFilterComponents = customFilterComponentsInfo.data;

                    } catch (e) {
                        console.error("[Overview][callConfigureCustomFilter] Error fetching filter data = ", e);

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;
                    }

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Deleted custom filter component',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Overview][createCustomFilter] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to delete custom filter component. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 34;
            this.loading = false;
        },
        callResetCustomFilter() {
            this.selectedCustomFilter = null;
            this.activeTab = 30;
        },
        getStockCodeName(code) {
            const stock = this.stockCodes.find(stock => stock.code === code);
            return stock ? stock.name : 'Unknown Code';
        },
        async onCustomFilterChange() {

            this.loading = true;

            if ((this.lastActiveTab === 20) ||
                (this.lastActiveTab === 21) ||
                (this.lastActiveTab === 22)) {
                this.activeTab = 23;
            } else if (this.lastActiveTab === 4) {
                this.activeTab = 4;
            } else {
                this.activeTab = 1;
            }

            try {
                const [customFilterComponentsInfo] = await Promise.all([
                    FilterComponentService.getFilterComponentsForFilter(this.selectedCustomFilter)
                ]);
                this.customFilterComponents = customFilterComponentsInfo.data;
            } catch (e) {
                console.error("[Overview][onCustomFilterChange] Error fetching filter data = ", e);
                this.loading = false;

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            }

            let tempSelectedColumnFields = []; // Use a temporary array to build the list

            const defaultMandatoryColumnField = "codeId129";
            tempSelectedColumnFields.push(defaultMandatoryColumnField);

            this.customFilterComponents.forEach((item) => {
                if (item.code && this.columnConfig.some(config => config.field === item.code) && !tempSelectedColumnFields.includes(item.code)) {
                    tempSelectedColumnFields.push(item.code);
                }
            });

            this.selectedColumns = tempSelectedColumnFields;

            try {
                this.lazyParams.customFilterId = this.selectedCustomFilter;

                if (this.lastActiveTab === 20) {

                    const [stockDataInfo] = await Promise.all([
                        StockDataService.searchStockDataForCountryAndSpecificCode(
                            this.selectedCountry, 'S', this.searchCriteria.value, this.lazyParams)
                    ]);

                    this.stockData = Array.isArray(stockDataInfo.data.content) ? stockDataInfo.data.content : [];
                    this.totalRecords = stockDataInfo.data?.totalElements || 0;

                } else if (this.lastActiveTab === 22) {

                    const [stockDataInfo] = await Promise.all([
                        StockDataService.searchStockDataForCountryAndSpecificCode(
                            this.selectedCountry, 'S', this.searchCriteria, this.lazyParams)
                    ]);

                    this.stockData = Array.isArray(stockDataInfo.data.content) ? stockDataInfo.data.content : [];
                    this.totalRecords = stockDataInfo.data?.totalElements || 0;

                } else if (this.lastActiveTab === 21) {

                    const [stockDataInfo] = await Promise.all([
                        StockDataService.processAdvancedSearchForStockData(
                            this.advancedSearchStockData, this.lazyParams)
                    ]);

                    this.stockData = Array.isArray(stockDataInfo.data.content) ? stockDataInfo.data.content : [];
                    this.totalRecords = stockDataInfo.data?.totalElements || 0;

                } else {
                    await this.loadData();
                }

            } catch (e) {
                console.error("Error applying custom filter or fetching data:", e);

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            } finally {
                this.loading = false;
            }
        },
        async onCompanyCodeClick(inputStockData) {
            this.loading = true;

            console.log("[Overview][onCompanyCodeClick] this.lastActiveTab = ", this.lastActiveTab);
            console.log("[Overview][onCompanyCodeClick] inputStockData = ", inputStockData);

            try {
                this.activeTab = 4;
                // this.lastActiveTab = 4;
                this.selectedFormat = "Extended";
                this.selectedCustomFilter = null;

                this.specificStockData = inputStockData;
                this.specificStockDataArray = [inputStockData];

                try {
                    const [stockHistoryInfo] = await Promise.all([
                        StockHistoryService.getStockHistory(inputStockData.exchangeId073, inputStockData.codeId129)
                    ]);

                    this.stockHistory = stockHistoryInfo.data;
                    this.stockHistory = stockHistoryInfo.data.filter(item => item.year >= 1999);
                } catch (e) {
                    console.error("[Overview][onCompanyCodeClick] Error fetching stock history data = ", e);

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }

                this.onStockDataStockHistoryOptionChange();

                this.chartKey++;
                this.loading = false;

            } finally {
                this.loading = false; // Hide the spinner
            }
        },
        async onStockDataTimePeriodChange() {
            this.loading = true;

            try {
                const timePeriodMap = {
                    "5": -5,
                    "10": -10,
                    "15": -15,
                    "20": -20,
                    "Maximum": -26
                };

                const sliceSize = timePeriodMap[this.selectedStockDataTimePeriod] || undefined;

                var filteredStockHistory = this.stockHistory.filter(item =>
                    item.year === 2025 ? item.eps !== null && item.eps !== 0 : true
                );

                var recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                let selectedOption = "dividendPerShare";
                let selectedLabel = "Dividends Per Share";

                if (this.selectedStockDataStockHistoryOption === "EPS") {
                    selectedOption = "eps";
                    selectedLabel = "EPS";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.eps !== null && item.eps !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else if (this.selectedStockDataStockHistoryOption === "LSP") {
                    selectedOption = "lowSharePrice";
                    selectedLabel = "Low Price";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.lowSharePrice !== null && item.lowSharePrice !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else if (this.selectedStockDataStockHistoryOption === "HSP") {
                    selectedOption = "highSharePrice";
                    selectedLabel = "High Price";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.highSharePrice !== null && item.highSharePrice !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else if (this.selectedStockDataStockHistoryOption === "ASP") {
                    selectedOption = "averageSharePrice";
                    selectedLabel = "Average Price";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.averageSharePrice !== null && item.averageSharePrice !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else {
                    selectedOption = "dividendPerShare";
                    selectedLabel = "Dividends Per Share";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.dividendPerShare !== null && item.dividendPerShare !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                }

                if (selectedOption) {
                    this.lineData = {
                        labels: recentYears.map(item => item.year),
                        datasets: [
                            {
                                label: selectedLabel, // Use the name from the selected option
                                data: recentYears.map(item => {
                                    const value = item[selectedOption];
                                    return (typeof value === 'number' && !isNaN(value)) ? value : null;
                                }),
                                fill: false,
                                borderColor: '#42A5F5',
                                tension: 0.4
                            }
                        ]
                    };
                } else {
                    console.warn("[Overview][onStockDataStockHistoryOptionChange] No matching option found for code:", this.selectedStockHistoryOptionCode);
                }

                this.lineOptions = {
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'top'
                        }
                    },
                    scales: {
                        x: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Years'
                            }
                        },
                        y: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Value'
                            }
                        }
                    }
                };

                this.loading = false;

            } finally {
                this.loading = false;
            }

        },
        async onStockDataStockHistoryOptionChange() {
            this.loading = true;

            try {
                const timePeriodMap = {
                    "5": -5,
                    "10": -10,
                    "15": -15,
                    "20": -20,
                    "Maximum": -26
                };

                const sliceSize = timePeriodMap[this.selectedStockDataTimePeriod] || undefined;

                var filteredStockHistory = this.stockHistory.filter(item =>
                    item.year === 2025 ? item.eps !== null && item.eps !== 0 : true
                );

                var recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                let selectedOption = "dividendPerShare";
                let selectedLabel = "Dividends Per Share";

                if (this.selectedStockDataStockHistoryOption === "EPS") {
                    selectedOption = "eps";
                    selectedLabel = "EPS";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.eps !== null && item.eps !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else if (this.selectedStockDataStockHistoryOption === "LSP") {
                    selectedOption = "lowSharePrice";
                    selectedLabel = "Low Price";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.lowSharePrice !== null && item.lowSharePrice !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else if (this.selectedStockDataStockHistoryOption === "HSP") {
                    selectedOption = "highSharePrice";
                    selectedLabel = "High Price";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.highSharePrice !== null && item.highSharePrice !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else if (this.selectedStockDataStockHistoryOption === "ASP") {
                    selectedOption = "averageSharePrice";
                    selectedLabel = "Average Price";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.averageSharePrice !== null && item.averageSharePrice !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                } else {
                    selectedOption = "dividendPerShare";
                    selectedLabel = "Dividends Per Share";

                    filteredStockHistory = this.stockHistory.filter(item =>
                        item.year === 2025 ? item.dividendPerShare !== null && item.dividendPerShare !== 0 : true
                    );

                    recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;
                }

                if (selectedOption) {
                    // Set up lineData with the appropriate label and data based on the selected option code
                    this.lineData = {
                        labels: recentYears.map(item => item.year),
                        datasets: [
                            {
                                label: selectedLabel, // Use the name from the selected option
                                data: recentYears.map(item => item[selectedOption] != null ? item[selectedOption] : 0),
                                fill: false,
                                borderColor: '#42A5F5',
                                tension: 0.4
                            }
                        ]
                    };
                } else {
                    console.warn("[Overview][onStockDataStockHistoryOptionChange] No matching option found for code:", this.selectedStockHistoryOptionCode);
                }

                this.lineOptions = {
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'top'
                        }
                    },
                    scales: {
                        x: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Years'
                            }
                        },
                        y: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Value'
                            }
                        }
                    }
                };

                this.loading = false;

            } finally {
                this.loading = false; // Hide the spinner
            }
        },
    }
};
</script>

<style scoped>
.p-multiselect-panel .p-multiselect-items {
    scroll-behavior: auto !important;
}

a {
    text-decoration: none;
}


.highlight {
    background-color: #EEA839;
    color: black;
}

.status-badge {
    border-radius: var(--border-radius);
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.status-badge {
    &.status-DT {
        background: #E5C7BCFF;
        color: #BE5306FF;
    }
}
</style>
